import type {
  InvoiceQueryModel,
  OrderInvoiceInfoModel,
  SaleInvoiceInfoModel,
} from '@/model/orderInvoice';
import type { ResultModel } from '@/model/viewModel';
import { post, type ApiResult } from '@/utils/api';

export const getOrderInvoiceList = (
  data: InvoiceQueryModel,
): Promise<ApiResult<ResultModel<OrderInvoiceInfoModel>>> =>
  post<ResultModel<OrderInvoiceInfoModel>>('/order/invoice/select', data);

export const getSaleInvoiceList = (
  data: InvoiceQueryModel,
): Promise<ApiResult<ResultModel<SaleInvoiceInfoModel>>> =>
  post<ResultModel<SaleInvoiceInfoModel>>('/sale/invoice/select', data);
